import React, { useState } from 'react';

const IPTB = (props) => {

    const [val, setVal] = useState(props.obj.value);
    const change = (val) => {
        setVal(val);
        props.setValue(props.obj.id, val)
    }

    const inputType = (type) => {
        switch (type) {

            case "number": return "number";
            case "date": return "date";
            case "email": return "email";
            default: return "text";
        }
    }

    return (
        <div className="form-group col-md-12">
            <label>{props.obj.label}</label>
            <input type={inputType(props.obj.format)} value={val} onChange={(e) => change(e.target.value)} className="form-control" readOnly={ props.readonly} />
        </div>

    );
}


export default IPTB;